module.exports = __webpack_public_path__ + "img/hist1.8ce5fee1.jpg";